// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__10IFy","options":"AnswerScale_options__3hgMu","selected":"AnswerScale_selected__2ZKvK"};